import Vue from "vue";
// import './plugins/vuetify'
import vuetify from "@/plugins/vuetify"; // path to vuetify export

import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import nb from "./locales/vuetify/nb.ts";
import es from "./locales/vuetify/es.ts";
import en from "./locales/vuetify/en.ts";
import i18n from "./i18n";
import Croppa from "vue-croppa";

const VueMoment = require("vue-moment");

const moment = require("moment");
// require('moment/locale/es')
Vue.use(VueMoment, { moment });

let _language =
  window.navigator.userLanguage ||
  window.navigator.language ||
  process.env.VUE_APP_I18N_LOCALE;

i18n.locale = localStorage.getItem("setlanguage") || _language;
Vue.moment.locale(i18n.locale);
localStorage.setItem("detectedlanguage", Vue.moment().locale());
// Vuetify.lang.current = Vue.moment().locale();
// Vue.use(Vuetify, {
//   iconfont: "fa",
//   lang: {
//     locales: { nb, es, en },
//     current: Vue.moment().locale()
//   }
// });
Vue.config.productionTip = false;

Vue.use(Croppa);
import "vue-croppa/dist/vue-croppa.css";

import App from "./App.vue";
import store from "./store/store";
import router from "./router/router";
// import './registerServiceWorker'
// import '../public/registerServiceWorker'
import './registerServiceWorker';

import { mapGetters } from "vuex";

Vue.filter("localizeDate", function(value) {
  if (!value) return new Date(0);
  value = new Date(value);
  var localOffset = value.getTimezoneOffset() * 60000;
  var localTime = value.getTime();
  value = localTime - localOffset;
  value = new Date(value);
  return value;
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
  watch: {
    getLang(newLocale) {
      this.changeLocale(newLocale);
    }
  },
  computed: {
    ...mapGetters(["getLang"])
  },
  methods: {
    changeLocale(newLocale) {
      this.$i18n.locale = newLocale;
      this.$moment.locale(newLocale);
      this.$vuetify.lang.current = newLocale;
      localStorage.setItem("setlanguage", newLocale);
      this.$store.dispatch("UPDATE_ALL_LANGUAGE_RELATED");
    }
  },
  mounted() {
    let _thisLanguage =
      localStorage.getItem("setlanguage") ||
      localStorage.getItem("detectedlanguage") ||
      "en";
    this.changeLocale(_thisLanguage);
  }
}).$mount("#app");
